module.exports = __webpack_public_path__ + "img/hiking_1413_1.b9e5f9ff.jpg";